import React from 'react';

import {
  Flex,
  Text
} from '@chakra-ui/react';

const Informacao = ({ title, info, bgColor, mt, isHead }) => {
  
  return (
    <Flex
      w="100%"
      backgroundColor={bgColor}
      mt={mt ? mt : "0px"}
    >
      <Flex
        w="50%"
        py="12px"
        px="24px"
      > 
        <Text
          fontWeight={ isHead ? 700 : 500}
          fontSize={ isHead ? "0.75rem" : "14px"}
          lineHeight="21.6px"
          color="#797A80"
        >
          {title}
        </Text>
      </Flex>
      <Flex
        w="50%"
        py="12px"
        px="24px"
      >
        <Text
          fontWeight={ isHead ? 700 : 500}
          fontSize={ isHead ? "0.75rem" : "14px"}
          lineHeight="21.6px"
          color="#797A80"
          wordBreak="break-word"
        >
          {info}
        </Text>
      </Flex>
    </Flex>
  );
}

export default Informacao;